import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { MenuItem } from 'primeng/components/common/menuitem';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NavMenuComponent implements OnInit {
  items: MenuItem[];

  constructor() { }

  ngOnInit() {
    this.items = [
      {
        styleClass: 'main-nav-prefix'
      },
      {
          label: 'Home',
      },
      {
          label: 'Properties'
      },
      {
          label: 'Messages'
      },
      {
          label: 'Reports',
          items: [
              {label: 'Some Report'},
              {label: 'Some Other Report'}
          ]
      }
    ];
  }

}
